
import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    DECLINE_SUBSTITUTOR: {
        url: "decline-substitutor",
        method: "post",
    },
};

export const useDeclineSubstitutor = () =>
    useApiFetcherSWR(API_ENDPOINT.DECLINE_SUBSTITUTOR);